type EnvVar = keyof NodeJS.ProcessEnv;

interface UfoEnvVars {
  REACT_APP_GOOGLE_ANALYTICS: string;
}

const REQUIRED_ENV_VARS: readonly EnvVar[] = [
  "REACT_APP_GOOGLE_ANALYTICS",
] as const;

const processEnvVars = (env: NodeJS.ProcessEnv): UfoEnvVars => {
  const missingEnvVars: EnvVar[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const requiredEnvVar of REQUIRED_ENV_VARS) {
    if (env[requiredEnvVar] === undefined) {
      missingEnvVars.push(requiredEnvVar);
    }
  }

  if (missingEnvVars.length > 0) {
    throw new TypeError(
      `Required environment variables not found: ${missingEnvVars.join(", ")}`
    );
  }

  return {
    ...env,
  } as UfoEnvVars;
};

const { REACT_APP_GOOGLE_ANALYTICS } = processEnvVars(process.env);

export const ENVIRONMENT: UfoEnvVars = {
  REACT_APP_GOOGLE_ANALYTICS,
};
